import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderProductMarkedAsIgnoredByOrderPrice(
        props: TypicalMessageProps<'order-product.marked-as-ignored-by-price'>
) {
    return <TypicalMessage
            model={props.model}
            options={props.options}
            optionsKey={props.optionsKey}
    />;
}
